export const mapboxToken =
  "pk.eyJ1IjoiY29oZXJlbnphIiwiYSI6ImNsanI4MXI0cTBmaWMzc3FuNTQwZTMwamUifQ.tolQPMM1XDvhX0DW7k3neg";
